import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);

  const showToast = useCallback((message, type = "success") => {
    setToast({ message, type });
    setVisible(true);

    // clear previous timers (fix overlap bug)
    if (window.toastTimer) clearTimeout(window.toastTimer);
    if (window.toastRemoveTimer) clearTimeout(window.toastRemoveTimer);

    if (type !== "loading") {
      window.toastTimer = setTimeout(() => setVisible(false), 2500);
      window.toastRemoveTimer = setTimeout(() => setToast(null), 3000);
    }
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {toast && (
        <div
          className={`fixed top-4 right-4 z-50 px-4 py-2 rounded shadow-lg text-white text-sm font-medium
            transition-opacity duration-500 ease-in-out
            ${visible ? "opacity-100" : "opacity-0"}
            ${
              toast.type === "success"
                ? "bg-green-600"
                : toast.type === "error"
                  ? "bg-red-600"
                  : "bg-blue-600"
            }
          `}
        >
          {toast.message}
        </div>
      )}
    </ToastContext.Provider>
  );
}
